/** @format */
import { css } from 'styled-components';

import { largeTablet, smallTablet } from '@toucan/helpers/media-queries';

import { DrawerProps } from './index';

/**
 * Base styles for the drawer component
 *
 * @param {DrawerProps} props The drawer properties object
 * */
const baseStyles = (props: DrawerProps) => css`
    display: flex;
    flex-direction: column;
    width: 50vw;
    min-width: 64rem;
    height: 100vh;
    box-shadow: var(--effects-shadow-md);
    position: fixed;
    top: 0;
    background: var(--colors-surface-primary);
    z-index: 9999;

    .close-button {
        margin: 2.4rem 2.4rem 0 0;
    }

    .header {
        display: flex;
        justify-content: flex-end;
        flex: 0 0 auto;
    }

    .contents {
        flex: 1;
        overflow-y: auto;
        overflow-x: visible;
    }
`;

/**
 * Large tablet styles for the drawer component
 *
 * */
const largeTabletStyles = () => css`
    width: 75vw;
`;

/**
 * Small tablet styles for the drawer component
 *
 * */
const smallTabletStyles = () => css`
    width: calc(100vw - 3.6rem);
    min-width: 0;
    height: 100dvh;
`;

/**
 * The drawer component styles
 *
 * @param {DrawerProps} props The drawer properties object
 * */
export const styles = (props: DrawerProps) => css`
    ${baseStyles(props)}
    ${largeTablet(largeTabletStyles())}
    ${smallTablet(smallTabletStyles())}
`;
